// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"45dfcf28","465":"a259fd5f","562":"e3e298a1","631":"af0b3a80","678":"c2a79f11","747":"272e287b","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};